import { $getReferenceCitationNodes } from './getReferenceCitationNodes';
import { $reorderNodes } from './reorderNodes';
import { $setNodeTextWithNumbersRange } from './setNodeText';

export function $applyReferenceCitationNumbering(
  referencesMap: Record<string, number>,
  isPreview = false,
): void {
  $getReferenceCitationNodes().forEach((node) => {
    $reorderNodes(node, referencesMap);
    $setNodeTextWithNumbersRange(node, referencesMap, isPreview);
  });
}
